// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__4-HGc","registerButton":"footer_registerButton__vLS9k","cancelButton":"footer_cancelButton__iolIx","btnText":"footer_btnText__4YS9z"};